import {
    COMPOSE_ONLY_ATTACHMENT_CONTENT_START,
    COMPOSE_ONLY_ATTACHMENT_CONTENT_END,
} from 'owa-attachment-link-common';

const contentToRemove = new RegExp(
    `<!--${COMPOSE_ONLY_ATTACHMENT_CONTENT_START}-->.*?<!--${COMPOSE_ONLY_ATTACHMENT_CONTENT_END}-->`,
    'gim'
);

export function removeComposeOnlyContent(html: string): string {
    if (html) {
        return html.replace(contentToRemove, '');
    } else {
        return html;
    }
}
